import Vue from 'vue';
import Vuex from 'vuex';
import { initializeApp } from "firebase/app";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import createPersistedState from 'vuex-persistedstate';

import driverModule from './modules/driver';
import authModule from './modules/auth';
import fastQuoteModule from './modules/fastquote';
import bookingModule from '@/state/modules/booking';
import emailModule from '@/state/modules/email';
import adminModule from "@/state/modules/admin";

//setup firebaseConfig production
var firebaseConfig = {
  apiKey: "AIzaSyAnE1Q6058-GTlc9tK4cmbGX0EvqvflM8U",
  authDomain: "dash-waste-usa.firebaseapp.com",
  projectId: "dash-waste-usa",
  storageBucket: "dash-waste-usa.appspot.com",
  messagingSenderId: "537916132916",
  appId: "1:537916132916:web:9dca4451ea145366f10461",
  measurementId: "G-LWSFB7HR2B"
};
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

Vue.use(Vuex);
const store = new Vuex.Store({
  plugins: [createPersistedState({
    paths: ['auth'],
    storage: window.sessionStorage
  })],
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    driver: driverModule,
    auth: authModule,
    fastQuote: fastQuoteModule,
    booking: bookingModule,
    email: emailModule,
    admin: adminModule
  }
});
onAuthStateChanged(auth, (user) => {
  if(user){
    void store.dispatch('auth/completeLogin');
  }
});

export default store;